import React, { useContext } from "react";
import { LuBuilding2 } from "react-icons/lu";
import { Language } from "../../App";
import AccountResultsComp from "./AccountResultsComp";

const getFacilitySubtitle = (facility) => {
  const specializations = facility?.specializations
    ?.map((specialization) => specialization?.name)
    .filter(Boolean)
    .join(", ");

  return (
    facility?.facility_profile?.type ||
    facility?.sub_type ||
    specializations ||
    "Hospital / Clinic"
  );
};

export default function FacilityResultsComp({ data, loading }) {
  const { lang } = useContext(Language);

  return (
    <AccountResultsComp
      data={data}
      loading={loading}
      id="facility"
      icon={<LuBuilding2 />}
      title={lang?.hospital_clinic || "Hospital/Clinic"}
      fallbackName="Hospital / Clinic"
      getSubtitle={getFacilitySubtitle}
    />
  );
}
